import { CompanyRow } from 'components/CompanyRow';
import { LinearProgress } from 'components/LinearProgress';
import { FC } from 'react';
import { ICompanyList } from 'types/Company';

import LeftIcon from '@mui/icons-material/ChevronLeft';
import RightIcon from '@mui/icons-material/ChevronRight';
import {
  Fab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export interface ICompanyListProps extends ICompanyList {
  currentPage: number;
  setPage: Function;
  maxPage: number;
  loading: boolean;
}

export const CompanyList: FC<ICompanyListProps> = ({
  list,
  currentPage,
  setPage,
  maxPage,
  loading,
}) => {
  const previousPage = () => {
    if (currentPage > 1) {
      setPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    setPage(currentPage + 1);
  };

  return (
    <TableContainer component={Paper} sx={{ mb: 5 }}>
      {loading && <LinearProgress />}
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Razão Social</strong>
            </TableCell>
            <TableCell>
              <strong>CNPJ</strong>
            </TableCell>
            <TableCell align="center" width={50}>
              <strong>Ação</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list?.map((company) => (
            <CompanyRow key={company._id} company={company} />
          ))}
          <TableRow>
            <TableCell align="right" colSpan={5}>
              <Typography>
                <Fab
                  color="primary"
                  size="small"
                  aria-label="remove"
                  disabled={currentPage <= 1}
                  onClick={previousPage}
                >
                  <LeftIcon />
                </Fab>
                <Fab
                  disabled
                  size="small"
                  aria-label="add"
                  sx={{ ml: 1, mr: 1 }}
                >
                  {currentPage}
                </Fab>
                <Fab
                  color="primary"
                  size="small"
                  aria-label="add"
                  disabled={currentPage === maxPage}
                  onClick={nextPage}
                >
                  <RightIcon />
                </Fab>
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
